module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "listing-wrapper"
    }
  }, [_c('div', {
    style: ({
      backgroundColor: _vm.color
    })
  }, [_c('div', {
    staticStyle: {
      "padding-top": "2px",
      "padding-bottom": "40px"
    }
  }, [_c('span', {
    staticClass: "not-found container",
    staticStyle: {
      "display": "table",
      "width": "100%",
      "color": "#3498db",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "row justify-content-md-center justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 text-center notfound"
  }, [_c('img', {
    attrs: {
      "src": _vm.staticImg + 'notfound.png',
      "alt": "404 Not Found"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "headerTwo"
  }, [_vm._v("We can't seem to find the page you are looking for")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "mx-2 people-may-like-txt mt-4"
  }, [_vm._v("You may also like:-")]), _vm._v(" "), _c('div', {
    staticClass: "container w-100 p-2"
  }, [_c('div', {
    staticClass: "row pro-list"
  }, [_vm._l((_vm.noProductListData), function(prm, index) {
    return _c('div', {
      key: prm.id + index,
      staticClass: "col-lg-3 col-md-6 col-6"
    }, [_c('img-block', {
      attrs: {
        "parry": prm.images !== [] ? prm.imageUrl : [],
        "position": index,
        "isExclusive": _vm.isExclusive,
        "imageH": 400,
        "imageW": 300,
        "index": index,
        "urlKey": prm.product_slug,
        "productTitle": prm.product,
        "productCat": prm.artistname,
        "productPrice": prm.price,
        "exclusivePrice": prm.exclusive_price,
        "jitValue": prm.jitValue,
        "pstock": prm.stock,
        "spprice": prm.splPrice || prm.spl_price,
        "listCat": prm.category,
        "genderType": prm.genderType,
        "pclass": 'prd' + prm.id + prm.category + 'img',
        "product": prm,
        "isStockConfig": prm.prodQty,
        "prodType": prm.prodType,
        "imageCount": _vm.noProductListData.length,
        "showImageBlurSoldOutDesign": true,
        "callerComp": 'No Product Found',
        "wishlistItemsIDs": _vm.wishlistItemsIDs,
        "updateWishlist": _vm.updateWishlist,
        "prm": prm
      },
      nativeOn: {
        "click": function($event) {
          _vm.crossSellEventHandler(prm)
        }
      }
    })], 1)
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "mt40 mb20 row w-full justify-content-center align-items-center load-more-loader"
  }, [_c('img', {
    staticClass: "spinner-3",
    attrs: {
      "src": _vm.staticImgServer + 'assets/spinner-3.gif',
      "alt": "Loader"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.infiniteScrollError) ? _c('div', {
    staticClass: "mt20 mb20 row w-full justify-content-center align-items-center"
  }, [_c('span', {
    staticClass: "fbold",
    staticStyle: {
      "color": "#ed2d2f"
    }
  }, [_vm._v("OOPS ! Something went Wrong, Please try Again")])]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33cc99b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NoProductFoundListing.vue
// module id = 915
// module chunks = 117